import React from 'react';
import Select from 'react-select';

import {
  Form,
  FormGroup,
  Button,
  Row,
  Col,
  Label,
  Input,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import PaymentRules from '../PaymentRules';
import SMSNotificationsModal from '../../../modals/SMSNotificationsModal/SMSNotificationsModal';
import { currencyToSign } from '../../../utils/utils';
// import PaymentsConvertingAlert from '../PaymentsConvertingAlert';
// import PaymentsBankCardChangesAlert from '../PaymentsBankCardsChangesAlert';
const View = ({
  data: {
    errors,
    data,
    authType,
    rules,
    selectedCurrency,
    smsConfirmModalShow,
    loading,
    purses,
    currencies,
    sessionId,
    validTill,
    error,
    status,
    intl,
    isSlaveAndNotInMember,
    isUserBlocked,
    selected,
    rates,
    isCurrencyConverting,
    wallets,
    toCurrency,
    isUserQuar,
    transport,
  },
  onSubmit,
  onSelectCurrency,
  getFormattedMessage,
  onAmountChange,
  getOptions,
  onInputChange,
  onSelectPurse,
  messageAlert,
  showAlertPayment,
  setMessageAlert,
  toggleModal,
  selectCurrenciesNoResultsText,
  selectNoResultsText,
  getCurrencyOptions,
  onToPayoutChange,
  formatOptionLabel,
  renderConverToCurrencyTooltip,
  // hasRUBankCards,
}) => {
  return (
    <Form className="finances-payments-form" onSubmit={onSubmit} autoComplete="off">
      {/* OFFERRUM-1613 */}
      {/* <PaymentsConvertingAlert /> */}
      {/* {hasRUBankCards ? <PaymentsBankCardChangesAlert /> : null} */}
      <Row className="row-1">
        <Col xl="4" lg={{ size: 6 }} md="8">
          <FormGroup className="form-group-upper-label">
            <div>
              <Select
                placeholder={getFormattedMessage('payments.choose_purse', 'Pay on...')}
                onInputChange={onInputChange}
                className={cn('purses-select', {
                  'has-error': errors.purse,
                })}
                onChange={onSelectPurse}
                value={selectedCurrency && data.purse}
                optionRenderer={formatOptionLabel}
                disabled={selectedCurrency === null}
                noResultsText={selectNoResultsText}
                clearable={false}
                multi={false}
                tabIndex="3"
                options={getOptions(purses)}
                styles={{
                  placeholder: () => ({
                    // ...provided,
                    // workaround zone
                    pointerEvents: 'none',
                    userSelect: 'none',
                    MozUserSelect: 'none',
                    WebkitUserSelect: 'none',
                    msUserSelect: 'none',
                  }),
                  input: (css) => ({
                    ...css,
                    /* expand the Input Component div */
                    flex: '1 1 auto',
                    //outline: "1px dotted red",
                    /* expand the Input Component child div */
                    '> div': {
                      width: '100%',
                    },
                    /* expand the Input Component input */
                    input: {
                      width: '100% !important',
                      textAlign: 'left',
                    },
                  }),
                }}
              />
            </div>
          </FormGroup>
        </Col>
        {/* <Col xl="1" lg="3" md="2">
          <FormGroup className='form-group-upper-label'>
            <Select
              className={cn('purses-select', { 'has-error': errors.purse })}
              options={getCurrencyOptions(currencies)}
              value={selectedCurrency}
              onChange={onSelectCurrency}
              placeholder={getFormattedMessage('payments.choose_currency', 'Currency')}
              noResultsText={selectCurrenciesNoResultsText}
              clearable={false}
              multi={false}
              tabIndex="1"
              disabled={isUserBlocked}
            />
          </FormGroup>
        </Col> */}
        <Col xl="3" lg="5" md="5" className="payments-amount">
          <FormGroup
            className={cn('d-flex', 'form-group-upper-label', { 'has-error': errors.amount })}
          >
            <Label htmlFor="payments.amount">
              <FormattedMessage id="payments.amount.label" defaultMessage="Payments amount" />
            </Label>
            <Input
              value={data.amount === 0 ? '' : data.amount}
              onChange={(e) =>
                onAmountChange(
                  e.target.value,
                  rules,
                  selectedCurrency,
                  toCurrency,
                  rates,
                  data.purse,
                )
              }
              maxLength="12"
              tabIndex="2"
              disabled={isUserBlocked}
              id="payments.amount"
            />
            {errors.amount && <small className="form-text">{errors.amount}</small>}
          </FormGroup>
        </Col>

        <Col xl="3" lg="4" md="5" className="payments-total">
          <FormGroup className="d-flex form-group-upper-label">
            <Label htmlFor="payments.total">
              <FormattedMessage id="payments.total" defaultMessage="To payoff" />
            </Label>
            <InputGroup id="payments-total">
              <Input
                value={data.amountToPayout}
                id="payments.total"
                onChange={(e) =>
                  onToPayoutChange(
                    e.target.value,
                    rules,
                    selectedCurrency,
                    toCurrency,
                    rates,
                    data.purse,
                  )
                }
              />

              {/* <InputGroupAddon addonType="append" id="currency-sign">
                <InputGroupText>{currencyToSign(toCurrency)}</InputGroupText>
              </InputGroupAddon> */}
              {isCurrencyConverting && renderConverToCurrencyTooltip()}
            </InputGroup>
          </FormGroup>
        </Col>
        {/* OFFERUM-2374 */}
        <Button
          color="primary"
          className="payments-order-btn"
          outline
          size="md"
          disabled={
            !data.amount ||
            data.amount <= 0 ||
            data.purse === null ||
            loading ||
            !selected ||
            isUserBlocked ||
            isSlaveAndNotInMember ||
            isUserQuar
          }
          tabIndex="4"
        >
          <FormattedMessage id="payments.add_payment" defaultMessage="Add payment" />
        </Button>

        {messageAlert && (
          <Col xl="12" lg="10" md="12" xs="12" className="col-3">
            <PaymentRules
              rules={rules}
              currency={selectedCurrency}
              intl={intl}
              purseId={data.purse}
              wallets={wallets}
            />
          </Col>
        )}
        {showAlertPayment && (
          <Col xl="12" lg="10" md="12" xs="12" className="col-3">
            <PaymentRules
              rules={rules}
              currency={selectedCurrency}
              intl={intl}
              purseId={data.purse}
              wallets={wallets}
              messageAlert={messageAlert}
              setMessageAlert={setMessageAlert}
            />
          </Col>
        )}
      </Row>

      <SMSNotificationsModal
        transport={transport ? transport : 'sms'}
        authType={authType}
        sessionId={sessionId}
        validTill={validTill}
        isOpen={smsConfirmModalShow}
        toggleModal={toggleModal}
        onSubmit={onSubmit}
        error={error}
        status={status}
      />
    </Form>
  );
};

export default View;
